<template>
  <!-- ADD Bank -->
  <v-layout row justify-center>
    <v-dialog v-model="editBankModal" persistent max-width="500px">
      <v-card>
        <form action="" @submit.prevent="submitForm()">
          <v-card-title>
            <v-flex xs11 sm11 md11><span class="headline">{{ $t('finance.updateBankTitle') }}</span></v-flex>
            <v-flex xs1 sm1 md1>
              <v-btn flat @click="closeEditBankModal(), $validator.reset()" class="close"
                ><span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn
              >
            </v-flex>
          </v-card-title>
          <v-card-text>
            <v-alert type="success" :value="checkAlert">
              {{ $t('finance.bankUpdatedSuccessfully') }}
            </v-alert>
            <v-alert type="error" :value="errorAlert">
              {{ $t('admin.pleaseUpdateAnything') }}
            </v-alert>
            <v-layout column>
              <v-flex xs12>
                <v-text-field
                  :label="$t('columns.bankName') + '*'"
                  v-model="editBankData.bank_name"
                  :error-messages="errors.collect('Bank Name')"
                  v-validate="'required'"
                  data-vv-name="Bank Name"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  :label="$t('columns.initialBalance') + '*'"
                  v-model="editBankData.initial_balance"
                  type="number"
                  :error-messages="errors.collect('Initial Balance')"
                  v-validate="'required|numeric'"
                  data-vv-name="Initial Balance"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              style="height:auto"
              @click="closeEditBankModal(), $validator.reset()"
              outline
              color="normal"
              >{{ $t('common.cancel') }}</v-btn
            >
            <v-btn type="submit" style="height:auto" class="rtl-mr-3pct" outline color="success"
              >{{ $t('common.update') }}</v-btn
            >
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>
  </v-layout>
  <!-- /ADD Bank -->
</template>

<script>
export default {
  props: [
    'editBank',
    'editBankData',
    'editBankModal',
    'checkAlert',
    'errorAlert',
    'closeEditBankModal'
  ],

  methods: {
    submitForm(event) {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.editBank()
        }
      })
    }
  }
}
</script>

<style>
/* Commented out problematic overflow styles to let Vuetify handle dialog scrolling naturally */
/*
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
.dialog-dialog--active-dialog--persistent {
  opacity: 1 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden !important;
  overflow-y: auto !important;
}
.dialog:not(.dialog--fullscreen) {
  max-height: 95%;
}
*/
</style>



// WEBPACK FOOTER //
// src/components/bank/editBank.vue